import { render, staticRenderFns } from "./UnReadMessage.vue?vue&type=template&id=1363405c&scoped=true"
import script from "./UnReadMessage.vue?vue&type=script&lang=js"
export * from "./UnReadMessage.vue?vue&type=script&lang=js"
import style0 from "./UnReadMessage.vue?vue&type=style&index=0&id=1363405c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1363405c",
  null
  
)

export default component.exports